exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cf:after{\n  content:\"\";\n  display: table;\n  clear: both;\n  border: 1px solid green;\n}\n", ""]);

// exports
